import Status from '../Result.Status.i18n';
import Detail from '../Result.Detail.i18n';
import custom from '@/f1/custom';
import codes from '@/f1/codes';
import DatePicker from 'vue2-datepicker';
import { api } from '@/f1/service';
import moment from 'moment-timezone'
import { Switch as cSwitch } from '@coreui/vue';
import WMDS_Agent_Call from '../service'

//restful api
//import { wmds as ws } from '@/f1/service/api'

//i18n_data
import _i18n_data from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components: { cSwitch, DatePicker, Detail, Status },
  data: () => {
    return {
      sync : { interval : 30 * 1000, th : undefined, status : false, task_key : '', timer : 0, timer_func : undefined },
      load_count : 0,
      loading : true,
      currentPage : 1,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
      codes,
      custom,
      site : {},
      sel_result : {},
      sel_status : {}
    }
  },
  watch : {
    currentPage() { this.load() }
  },
  computed: {
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    getRowCount () { return this.so.totalRows || 0; },
    fields() { return _i18n_data.i18n_fields[this.i18n || 'EN']; },
  },
  methods: {
    clear() {
      try {
        clearTimeout(this.sync.th)
        this.sync.th = undefined
        clearTimeout(this.sync.timer_func)
        this.sync.timer_func = undefined

        this.sel_status = Object.assign({})
        this.sel_result = Object.assign({})
        this.so.opt = Object.assign({})

        this.refresh()

      } catch (e) { console.log(e) }
    },
    timer() {
      try {
        this.sel_result = Object.assign({})
        // console.log("timer", this.sync.timer)
        if(this.sync.timer_func) {
          clearTimeout(this.sync.timer_func)
          this.sync.timer_func = undefined
        } else { this.sync.status = true; this.result_select() }

        if(this.sync.status) {
          this.sync.timer += -1
        } else {
          clearTimeout(this.sync.th)
          this.sync.th = undefined
        }

        if(this.sync.timer < 0) {
          this.sync.timer = this.sync.interval / 1000
          this.result_select()
        }
        this.sync.timer_func = setTimeout(this.timer, 1000)
      } catch (e) { console.log(e) }
    },
    async result_select() {
      try {
        // console.log(this.sync.status, 'this.sync.status')
        if(this.sync.status) {
          let rs = await WMDS_Agent_Call.status(this.sync.task_key)

          if(!rs || rs.error) {
            this.clear()
            return this.$toastr.e(`${_i18n_data._i18n_error.result_select[this.i18n]}`);
          }
          if(rs.pl.task_key != this.sync.task_key) { return console.log('not same, before request so ignore') }
          if(rs && rs.pl) { this.sel_status = Object.assign({}, this.sel_status, rs.pl) }
          // 3 은 quit 임, codes 참고
          if(this.sel_status.status == 3) { this.clear() }

        }
        this.$toastr.i(`${_i18n_data._i18n_info.update_check[this.i18n]}`)
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) }
    },
    async scan_stop(task_key){
      try {
        // TODO : 현재 응답 값이 없음 이거는 문제임
        if(this.sync.task_key == task_key) { this.clear() }
        console.info('request scaning stop', task_key)
        let rs = await WMDS_Agent_Call.stop(task_key)
        console.log(rs, 'result')
        this.$toastr.i(`${_i18n_data._i18n_info.scan_stop[this.i18n]}`)
        this.refresh()
      } catch(e) { console.log(e); this.$toastr.e(e.data ? e.data.message : e.statusText) , this.list() }
    },
    list() { this.$router.push({ name: 'wmds_result' }); this.$parent.$emit('refresh')},
    copy(task_key, fqdn) {
      try {
        var tempElem = document.createElement('textarea');
        tempElem.value =`${fqdn}|${task_key}`;
        document.body.appendChild(tempElem);
        tempElem.select();
        document.execCommand("copy");
        document.body.removeChild(tempElem);
        this.$toastr.i(`${i18n_data._i18n_info.ticket_copy[this.i18n]}`)
      } catch (e) { console.log(e); this.$toastr.i(`${i18n_data._i18n_error.copy_failed[this.i18n]}`) }
    },
    search_opt() {
      delete this.so.opt.is_alive // 통합된 부분이라서 이렇게 미사용하는 변수는 예외 처리 필요
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['finished_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k.endsWith('_count')) {
        return v === true ? { name : k, value : 1, op : '>=' } : { name : k, value : -1, op :  '>' }
      } else if(k.endsWith('_id')) {
        return { name : k, value : Number(v), op :  '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;

      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          // case '+1d' : sd = moment(sd).subtract(-1, 'd'); break;
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.sel_result = {}; this.refresh(); },
    refresh() { this.$refs._list && this.$refs._list.refresh(); this.sel_result = {}; this.sel_status = {} },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      this.loading = true
        this.so.currentPage = this.currentPage
        let so = {
          target : 'result', cmd : 'list',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.$route.params && this.$route.params.site_id) { so.body.and.push(this.set_op('site_id', this.$route.params.site_id, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_startTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_endTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'finished_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_startTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'finished_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w(`${i18n_data._i18n_warning.require_endTime[this.i18n]}`, `${i18n_data._i18n_warning.notice[this.i18n]}`); break; }
                cond = { name : k[i].slice(0, 11), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(cond.value == '%%' || cond.value === '') { continue; }
            if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
            else { so.body.or.push(cond) }
          }
        } else {
          let cond = this.set_op(this.so.sk, this.so.sv, so)
          // console.log(cond, cond.value != '%%' && cond.value != '')
          if(cond.value != '%%' && cond.value != '') { so.body.and.push(cond); }
        }
      return api.wmds.WMDS(so).then(rs => { this.so.totalRows = rs.total; this.$parent.$emit('loading', false); this.loading = false; return rs.body ? rs.body : []; })
      //return ws.result.list(so).then(rs => { this.so.totalRows = rs.total; this.$parent.$emit('loading', false); this.loading = false; return rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message || e.data.title ? e.data.title : e.statusText))
    },
    load_site() {
      try {
        let so = {
          target : 'site', cmd : 'detail',
          body : {
            id : this.$route.params.site_id
          },
        }
        api.wmds.WMDS(so).then(rs => { this.site = rs.body })
        //ws.site.detail(so).then(rs => { this.site = rs.body })
          .catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message || e.data.title ? e.data.title : e.statusText))
      } catch (e) { console.log('load failed', e) }
    },
    detail(id) { this.clear(); this.sel_result = Object.assign({}, this.sel_result, { id : id }); console.log(id, 'item') },
  },
  created() { console.log('result.vue', 'created'); },
  destroyed() { console.log('result.vue', 'destroyed'); this.clear() },
  mounted() { console.log('result.vue', 'mounted'); this.load_site() },
}
